import { GetShopWaysToWearItQuery } from './getShopWaysToWearIt';

type GetShopWaysToWearItQueryWrapper = {
  data: GetShopWaysToWearItQuery;
  extensions: {
    cost: {
      'shop-content-service': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
      'outfit-service': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
      'shop-product-catalog': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    shopContent: {
      id: 'shop_content-',
      productDetailsPage: {
        id: 'shop_product_details_page-',
        waysToWearItCollection: {
          id: 'WaysToWearItCollection:eyJhbmNob3Jfc2t1X2',
          title: 'Ways to wear it, just for you',
          description:
            'No endless browsing—we personalized outfits for you based on this item and your style.',
          items: {
            nodes: [
              {
                id: '1226148-440107-56267-432003',
                items: [
                  {
                    sticker: null,
                    laydown: {
                      maxHeight: 0.38,
                      maxWidth: 0.28,
                      x: 0.33,
                      y: 0.5,
                      xAnchor: 'right',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '1226148',
                      image: {
                        altText:
                          'Kolton Henley Hoodie Sweater  - Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.38,
                      maxWidth: 0.28,
                      x: 0.5,
                      y: 0.52,
                      xAnchor: 'center',
                      yAnchor: 'bottom',
                    },
                    shopProductVariant: {
                      id: '440107',
                      image: {
                        altText:
                          'Durant Performance Tee - Dark Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1503003357/xd1fkghrcz8rekon9rqs.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1503003357/xd1fkghrcz8rekon9rqs.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1503003357/xd1fkghrcz8rekon9rqs.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.28,
                      maxWidth: 0.26,
                      x: 0.68,
                      y: 0.5,
                      xAnchor: 'left',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '1690423',
                      image: {
                        altText:
                          'Club C 85 Vintage Leather Sneaker - Off-White - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1594657741/o6co0iox1idku8ohc226.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1594657741/o6co0iox1idku8ohc226.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1594657741/o6co0iox1idku8ohc226.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.3,
                      maxWidth: 0.24,
                      x: 0.5,
                      y: 0.62,
                      xAnchor: 'center',
                      yAnchor: 'top',
                    },
                    shopProductVariant: {
                      id: '2572731',
                      image: {
                        altText:
                          'Pullman Reflective Hybrid Short 10" - Dark Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1651081167/cbyiyrmxvd6c2qcyja9h.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1651081167/cbyiyrmxvd6c2qcyja9h.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1651081167/cbyiyrmxvd6c2qcyja9h.jpg',
                      },
                    },
                  },
                ],
              },
              {
                id: '1811901-23544-5667-1226148',
                items: [
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.3,
                      maxWidth: 0.3,
                      x: 0.34,
                      y: 0.5,
                      xAnchor: 'right',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '1226148',
                      image: {
                        altText:
                          'Kolton Henley Hoodie Sweater  - Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.2,
                      maxWidth: 0.26,
                      x: 0.68,
                      y: 0.5,
                      xAnchor: 'left',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '1811901',
                      image: {
                        altText:
                          'Gunmut Nubuck Banded Low Top Sneaker - Dark Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1607677100/k6dz9guuhciwuodseke6.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1607677100/k6dz9guuhciwuodseke6.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1607677100/k6dz9guuhciwuodseke6.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.34,
                      maxWidth: 0.28,
                      x: 0.5,
                      y: 0.44,
                      xAnchor: 'center',
                      yAnchor: 'bottom',
                    },
                    shopProductVariant: {
                      id: '1030259',
                      image: {
                        altText: 'Peter Performance Vee - Blue - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1653515773/s9bghnyhqfreajjnsfvq.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1653515773/s9bghnyhqfreajjnsfvq.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1653515773/s9bghnyhqfreajjnsfvq.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.4,
                      maxWidth: 0.24,
                      x: 0.5,
                      y: 0.52,
                      xAnchor: 'center',
                      yAnchor: 'top',
                    },
                    shopProductVariant: {
                      id: '2183307',
                      image: {
                        altText:
                          'Adley Straight Fit Avalon - Indigo - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1635298323/bn6xrzzuzjd0pjfqtdxw.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1635298323/bn6xrzzuzjd0pjfqtdxw.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1635298323/bn6xrzzuzjd0pjfqtdxw.jpg',
                      },
                    },
                  },
                ],
              },
              {
                id: '1226148-87654-439788-57392',
                items: [
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.38,
                      maxWidth: 0.28,
                      x: 0.33,
                      y: 0.5,
                      xAnchor: 'right',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '1226148',
                      image: {
                        altText:
                          'Kolton Henley Hoodie Sweater  - Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.38,
                      maxWidth: 0.28,
                      x: 0.5,
                      y: 0.52,
                      xAnchor: 'center',
                      yAnchor: 'bottom',
                    },
                    shopProductVariant: {
                      id: '439788',
                      image: {
                        altText: 'Durant Performance Tee - Blue - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1503003352/xzbayg91cbruntkuiqlm.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1503003352/xzbayg91cbruntkuiqlm.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1503003352/xzbayg91cbruntkuiqlm.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.28,
                      maxWidth: 0.26,
                      x: 0.68,
                      y: 0.5,
                      xAnchor: 'left',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '2333436',
                      image: {
                        altText: 'Waller Sandal - Blue - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1649199349/zlrfmtuppncrvt1xm0is.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1649199349/zlrfmtuppncrvt1xm0is.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1649199349/zlrfmtuppncrvt1xm0is.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.3,
                      maxWidth: 0.24,
                      x: 0.5,
                      y: 0.62,
                      xAnchor: 'center',
                      yAnchor: 'top',
                    },
                    shopProductVariant: {
                      id: '2509431',
                      image: {
                        altText:
                          'Blanchard Solano French Terry Short - Light Green - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1652720009/r6n63pzilucvotpfshiz.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1652720009/r6n63pzilucvotpfshiz.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1652720009/r6n63pzilucvotpfshiz.jpg',
                      },
                    },
                  },
                ],
              },
              {
                id: '45621-1226148-1384385-1253456',
                items: [
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.38,
                      maxWidth: 0.28,
                      x: 0.33,
                      y: 0.5,
                      xAnchor: 'right',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '1226148',
                      image: {
                        altText:
                          'Kolton Henley Hoodie Sweater  - Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.38,
                      maxWidth: 0.28,
                      x: 0.5,
                      y: 0.52,
                      xAnchor: 'center',
                      yAnchor: 'bottom',
                    },
                    shopProductVariant: {
                      id: '1384385',
                      image: {
                        altText:
                          'Responsible Roger Texture Feeder Stripe V-Neck - Blue - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1652389858/mxmdtcleug1ormfcjzpo.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1652389858/mxmdtcleug1ormfcjzpo.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1652389858/mxmdtcleug1ormfcjzpo.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.28,
                      maxWidth: 0.26,
                      x: 0.68,
                      y: 0.5,
                      xAnchor: 'left',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '2211054',
                      image: {
                        altText: 'Zig Dynamica 2.0 - Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1640198593/nqd0p46arm0fu6spbzfp.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1640198593/nqd0p46arm0fu6spbzfp.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1640198593/nqd0p46arm0fu6spbzfp.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.3,
                      maxWidth: 0.24,
                      x: 0.5,
                      y: 0.62,
                      xAnchor: 'center',
                      yAnchor: 'top',
                    },
                    shopProductVariant: {
                      id: '2450594',
                      image: {
                        altText: 'Kai Hybrid Short 10" - Navy - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1652318130/xo0skpg4uajo12rodgdt.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1652318130/xo0skpg4uajo12rodgdt.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1652318130/xo0skpg4uajo12rodgdt.jpg',
                      },
                    },
                  },
                ],
              },
              {
                id: '1226148-501383-158346-246754',
                items: [
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.3,
                      maxWidth: 0.3,
                      x: 0.34,
                      y: 0.5,
                      xAnchor: 'right',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '1226148',
                      image: {
                        altText:
                          'Kolton Henley Hoodie Sweater  - Grey - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1570231592/y2bj71btvsqlnhwsdorh.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.34,
                      maxWidth: 0.28,
                      x: 0.5,
                      y: 0.44,
                      xAnchor: 'center',
                      yAnchor: 'bottom',
                    },
                    shopProductVariant: {
                      id: '501383',
                      image: {
                        altText:
                          'Durant Performance Tee - Burgundy - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1516833304/nflmmaolplk2t1aghezk.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1516833304/nflmmaolplk2t1aghezk.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1516833304/nflmmaolplk2t1aghezk.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.4,
                      maxWidth: 0.24,
                      x: 0.5,
                      y: 0.52,
                      xAnchor: 'center',
                      yAnchor: 'top',
                    },
                    shopProductVariant: {
                      id: '2103087',
                      image: {
                        altText: 'HM Slim Fit Knit Jean - Indigo - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1642529042/tp0rocqa9b2egm4z7iws.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1642529042/tp0rocqa9b2egm4z7iws.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1642529042/tp0rocqa9b2egm4z7iws.jpg',
                      },
                    },
                  },
                  {
                    label: null,
                    laydown: {
                      maxHeight: 0.2,
                      maxWidth: 0.26,
                      x: 0.68,
                      y: 0.5,
                      xAnchor: 'left',
                      yAnchor: 'center',
                    },
                    shopProductVariant: {
                      id: '2220016',
                      image: {
                        altText: 'Hermosa Twill Sneaker - Brown - Flat Front',
                        baseUrl:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/',
                        mediaPath: '/v1638804959/vsmrgdnf4mcrzwju9je2.jpg',
                        medium:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_500/e_trim/f_auto,q_auto/e_replace_color:f2f3f4:300:ffffff/v1638804959/vsmrgdnf4mcrzwju9je2.jpg',
                        small:
                          'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/c_scale,h_300/e_replace_color:f2f3f4:300:ffffff/f_auto,q_auto/v1638804959/vsmrgdnf4mcrzwju9je2.jpg',
                      },
                    },
                  },
                ],
              },
            ],
          },
        },
      },
    },
  },
  extensions: {
    cost: {
      'shop-content-service': {
        maxQueryCost: 5000,
        requestedQueryCost: 5,
        actualQueryCost: 4,
      },
      'outfit-service': {
        maxQueryCost: 5000,
        requestedQueryCost: 607,
        actualQueryCost: 191,
      },
      'shop-product-catalog': {
        maxQueryCost: 5000,
        requestedQueryCost: 9,
        actualQueryCost: 161,
      },
    },
  },
} as GetShopWaysToWearItQueryWrapper;
